import type { PlaceSuggestion } from '../domain';
import { suggestPlaces } from '../infrastructure';

export async function resolvePlaceDestination(query: string): Promise<PlaceSuggestion[]> {
  if (!query || query.trim().length < 2) return [];
  return suggestPlaces(query.trim());
}
